<div class="w-96" *ngIf="config$ | async as config">
  <div class="border-b pl-6 pr-[10px] py-2 flex items-center justify-between">
    <div class="flex flex-col">
      <h3 class="m-0 text-base font-semibold" cdkFocusInitial>{{config?.title | translate}}</h3>
      <p class="m-0 text-sm text-gray-700">{{config?.description | translate}}</p>
    </div>
    <flow-button theme="light" variation="outline" (onClick)="closeSidePanel()">
      <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
    </flow-button>
  </div>

  <div class="flex flex-col gap-4 px-6 py-4">
    <ng-container *ngFor="let item of config?.children">
      <div class="flex flex-col gap-2">
        <h3 class="m-0 text-base font-semibold">{{ item?.title | translate}}</h3>
        <p class="m-0 text-sm text-gray-700">{{ item?.description | translate}}</p>
      </div>
    </ng-container>

    <flow-button
      *ngIf="config.manualKey"
      theme="primary"
      class="self-start mt-2"
      (onClick)="openAdditionalInstructions(config.manualKey)">
      {{ 'contextualModal.additionalInstructions.button' | translate }}
    </flow-button>
  </div>
</div>
